import type { RepFieldAudit } from "@repo/models";
import type { GridList } from "@repo/ui";
import type { AxiosRequestConfig } from "axios";

import { BaseController, BaseGridApi } from "@repo/baseCloud";

import type { FieldAuditsFilter } from "../pages/fieldAudits/types";

export const controller = "FieldAudits";

export default class FieldAuditsApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);

	static getFieldAudits(filter: FieldAuditsFilter, config?: AxiosRequestConfig) {
		return FieldAuditsApi.Get<GridList<RepFieldAudit>>("GetFieldAudits", filter, config);
	}

	static getFieldAuditTypes() {
		return FieldAuditsApi.Get<{ Value: number; Text: string }[]>("GetFieldAuditTypes");
	}

	static getLocations() {
		return FieldAuditsApi.Get<{ LocationId: number; Name: string }[]>("GetLocations");
	}

	/** Resolves with the new field audit's id, or with the scraper's error messages (still HTTP 200) when it fails. */
	static importFieldAudit(url: string) {
		return FieldAuditsApi.Post<number | string[]>("Import", {}, { url });
	}

	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "Field Audits");
	}

	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "Field Audits", settingsJson);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "FieldAudits");
	}
}
